import rawLogo from "../../assets/img/brands/BrandRaw.png";
import smackdownLogo from "../../assets/img/brands/BrandSM.png";
import nxtLogo from "../../assets/img/brands/BrandNXT.png";

export const brands = [
  { id: "raw", 
    name: "RAW", 
    image: rawLogo, 
    alt: "RAW brand logo" 
  },
  {
    id: "smackdown",
    name: "SMACKDOWN",
    image: smackdownLogo,
    alt: "SmackDown brand logo",
  },
  { id: "nxt", 
    name: "NXT", 
    image: nxtLogo, 
    alt: "NXT brand logo" 
  },
];
